module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAATtJREFUWEfFl8FKAlEUhj9fR5e6sZ0vUT6cq5ZCEBQEBUFSJmgEbRSCgqCgRRAkhAgiF45wGI86c+fOvbMfvu/+Z+afMzUSX7XEfMoI1IEesAA6vgfxFXDwPtAAHoGjmAIa/gJ0gWksAQ1/Bk6AV1+4u6/ICDR8IvC3MvAiAho+EvhHWXheAQ1/EPhnCHgeAQ0fAMfAdyj4IQENvxX4T0j4PgENvxH4b2j4LgENvxL4vAq4JaDhlwL/rwqeFdDwc4Evq4RnBVy5NIEzga+qhmcFhkA7pUDyEbhEtMSFtF60h3Az8qSvoSVxLUlEKyJLInoVWxJ3kkS0j5ElcS8SX6E6Iu9GlHQhsZIYSxLvZZPIm4AlEX0ptSTcWu4245lvEkUTsCSegFZsgU1tnwJ/KX7NfA+8dZ/vCIIJrAF4vFAhw9JJUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = P9/e
// module chunks = 1